import type { LegalBlock } from "../legal-document";

const content: LegalBlock[] = [
  {
    "type": "title",
    "text": "VAY3PHÚT – ĐIỀU KHOẢN VÀ ĐIỀU KIỆN SỬ DỤNG"
  },
  {
    "type": "heading",
    "text": "Lời mở đầu"
  },
  {
    "type": "paragraph",
    "text": "Vay3Phút là nền tảng do Công ty TNHH Công nghệ VayNext, có địa chỉ tại 296 Đường Xương Cá 1, 2, Bình Chánh, Thành phố Hồ Chí Minh, Việt Nam, sở hữu và vận hành. Trong Điều khoản này, các thuật ngữ “Vay3Phút”, “Công ty” hoặc “Chúng tôi” đều được dùng để chỉ Công ty TNHH Công nghệ VayNext."
  },
  {
    "type": "paragraph",
    "text": "Vay3Phút cung cấp và vận hành ứng dụng di động Vay3Phút (“Ứng dụng”) cùng website api.vay3phut.com (“Website”). Ứng dụng và Website sau đây được gọi chung là “Nền tảng”."
  },
  {
    "type": "paragraph",
    "text": "Nền tảng được xây dựng với mục đích hỗ trợ kết nối người có nhu cầu tìm hiểu hoặc tiếp cận các sản phẩm, dịch vụ tài chính với các tổ chức tài chính, đơn vị cung cấp dịch vụ, đối tác dữ liệu và các đối tác liên quan. Các sản phẩm có thể được giới thiệu thông qua Nền tảng bao gồm khoản vay tiêu dùng, thẻ tín dụng, bảo hiểm và các sản phẩm, dịch vụ tài chính hợp pháp khác."
  },
  {
    "type": "paragraph",
    "text": "Trong Điều khoản này, “Người dùng” hoặc “Quý khách” là cá nhân hoặc tổ chức truy cập, đăng ký tài khoản, sử dụng hoặc tương tác với Nền tảng."
  },
  {
    "type": "paragraph",
    "text": "Khi truy cập, đăng ký hoặc tiếp tục sử dụng Nền tảng, Quý khách xác nhận rằng mình đã đọc, hiểu và chấp thuận Điều khoản và Điều kiện sử dụng này, Chính sách Bảo mật cùng các chính sách hoặc thông báo khác được Vay3Phút công bố hợp lệ theo từng thời điểm."
  },
  {
    "type": "paragraph",
    "text": "Nếu không đồng ý với bất kỳ nội dung nào của Điều khoản này, Quý khách nên ngừng truy cập và không tiếp tục sử dụng các Dịch vụ trên Nền tảng."
  },
  {
    "type": "heading",
    "text": "1. Quy định chung"
  },
  {
    "type": "paragraph",
    "text": "Vay3Phút hoạt động với vai trò là nền tảng công nghệ hỗ trợ người dùng tìm kiếm và kết nối với các tổ chức tài chính, ngân hàng, đối tác cung cấp sản phẩm tài chính, đối tác dữ liệu hoặc các đơn vị hợp tác khác phù hợp với nhu cầu của người dùng."
  },
  {
    "type": "paragraph",
    "text": "Vay3Phút không phải là ngân hàng, tổ chức tín dụng hoặc công ty tài chính, và không trực tiếp thực hiện hoạt động cho vay, cấp tín dụng, nhận tiền gửi hoặc huy động vốn từ Người dùng."
  },
  {
    "type": "paragraph",
    "text": "Các khoản vay hoặc sản phẩm tài chính được hiển thị, giới thiệu hoặc kết nối thông qua Nền tảng do các tổ chức tài chính hoặc đối tác độc lập cung cấp. Việc thẩm định hồ sơ, quyết định phê duyệt, xác định hạn mức, lãi suất, phí, thời hạn, giải ngân, thu hồi khoản phải trả và các điều kiện giao dịch khác thuộc trách nhiệm của đơn vị cung cấp sản phẩm tương ứng."
  },
  {
    "type": "paragraph",
    "text": "Vay3Phút không thay mặt các tổ chức tài chính đưa ra quyết định cấp tín dụng và cũng không bảo đảm rằng bất kỳ hồ sơ nào của Người dùng sẽ được phê duyệt."
  },
  {
    "type": "paragraph",
    "text": "Trong phạm vi pháp luật cho phép, Nền tảng có thể cung cấp các chức năng hỗ trợ như giới thiệu sản phẩm, kết nối thông tin, xác minh dữ liệu, phân tích thông tin hoặc các công cụ hỗ trợ khác nhằm giúp Người dùng tiếp cận sản phẩm phù hợp hơn."
  },
  {
    "type": "paragraph",
    "text": "Khi Người dùng chủ động đăng ký hoặc gửi yêu cầu tìm hiểu sản phẩm, Vay3Phút và/hoặc đối tác liên quan có thể liên hệ với Người dùng thông qua số điện thoại, email hoặc phương thức liên lạc hợp pháp khác để xác minh nhu cầu, cung cấp thông tin và hỗ trợ quá trình đăng ký."
  },
  {
    "type": "paragraph",
    "text": "Các Dịch vụ của Vay3Phút có thể bao gồm:"
  },
  {
    "type": "list",
    "items": [
      "Kết nối Người dùng với tổ chức tài chính hoặc đơn vị cung cấp sản phẩm, dịch vụ tài chính;",
      "Hiển thị hoặc giới thiệu các sản phẩm phù hợp với nhu cầu do Người dùng cung cấp;",
      "Hỗ trợ xác minh những thông tin cần thiết phục vụ quá trình đánh giá hồ sơ;",
      "Hỗ trợ Người dùng tiếp cận hoặc tra cứu thông tin tín dụng thông qua đơn vị có thẩm quyền, nếu pháp luật cho phép;",
      "Với sự đồng ý hợp lệ của Người dùng, phân tích các dữ liệu tài chính, thu nhập, chi tiêu hoặc dữ liệu liên quan nhằm hỗ trợ việc tìm kiếm sản phẩm phù hợp;",
      "Cung cấp công cụ phân tích hoặc hỗ trợ đánh giá dựa trên dữ liệu được phép xử lý;",
      "Liên hệ và hỗ trợ Người dùng đối với sản phẩm hoặc dịch vụ mà Người dùng đã đăng ký hoặc thể hiện nhu cầu quan tâm."
    ]
  },
  {
    "type": "paragraph",
    "text": "Trong phạm vi cần thiết để cung cấp Dịch vụ, thông tin của Người dùng có thể được chuyển hoặc chia sẻ với tổ chức tài chính, nhà cung cấp dịch vụ và đối tác liên quan theo Chính sách Bảo mật, sự đồng ý của Người dùng khi pháp luật yêu cầu và quy định pháp luật Việt Nam về bảo vệ dữ liệu cá nhân."
  },
  {
    "type": "heading",
    "text": "2. Điều kiện sử dụng Nền tảng"
  },
  {
    "type": "paragraph",
    "text": "Khi sử dụng Vay3Phút, Người dùng xác nhận và bảo đảm rằng mình đáp ứng đầy đủ các điều kiện cần thiết để sử dụng Dịch vụ."
  },
  {
    "type": "paragraph",
    "text": "Đối với cá nhân, Người dùng phải từ đủ 18 tuổi trở lên, có đầy đủ năng lực hành vi dân sự và có khả năng tự mình xác lập, thực hiện các giao dịch theo quy định của pháp luật Việt Nam."
  },
  {
    "type": "paragraph",
    "text": "Đối với tổ chức, tổ chức đó phải được thành lập và hoạt động hợp pháp, đồng thời người thực hiện việc đăng ký hoặc sử dụng Nền tảng thay mặt tổ chức phải có thẩm quyền phù hợp."
  },
  {
    "type": "paragraph",
    "text": "Người dùng chỉ được sử dụng Nền tảng cho các mục đích hợp pháp và phù hợp với Điều khoản này."
  },
  {
    "type": "paragraph",
    "text": "Vay3Phút có thể từ chối cung cấp Dịch vụ, hạn chế quyền truy cập, tạm khóa hoặc chấm dứt tài khoản nếu có căn cứ hợp lý cho thấy:"
  },
  {
    "type": "list",
    "items": [
      "Người dùng không đáp ứng điều kiện sử dụng;",
      "Thông tin được cung cấp không chính xác, không đầy đủ, giả mạo hoặc gây hiểu nhầm;",
      "Có dấu hiệu gian lận hoặc lợi dụng Nền tảng;",
      "Người dùng sử dụng Dịch vụ cho hoạt động trái pháp luật;",
      "Người dùng vi phạm Điều khoản này hoặc quy định pháp luật có liên quan."
    ]
  },
  {
    "type": "paragraph",
    "text": "Trong phạm vi pháp luật cho phép, Vay3Phút có thể áp dụng các biện pháp cần thiết đối với tài khoản hoặc nội dung vi phạm nhằm bảo vệ Nền tảng, Người dùng khác và các bên liên quan."
  },
  {
    "type": "heading",
    "text": "3. Chấp thuận và cập nhật Điều khoản"
  },
  {
    "type": "paragraph",
    "text": "Việc Người dùng truy cập, tạo tài khoản hoặc sử dụng bất kỳ chức năng nào của Vay3Phút được hiểu là Người dùng đã đọc, hiểu và đồng ý tuân thủ Điều khoản này cùng các chính sách được công bố trên Nền tảng."
  },
  {
    "type": "paragraph",
    "text": "Vay3Phút có thể điều chỉnh, bổ sung hoặc cập nhật Điều khoản khi cần thiết để phù hợp với việc vận hành Dịch vụ, thay đổi về sản phẩm, yêu cầu quản lý hoặc quy định pháp luật."
  },
  {
    "type": "paragraph",
    "text": "Nội dung cập nhật sẽ được công bố trên Nền tảng hoặc thông báo cho Người dùng bằng phương thức phù hợp. Trừ trường hợp có quy định khác, phiên bản mới sẽ có hiệu lực kể từ thời điểm được công bố."
  },
  {
    "type": "paragraph",
    "text": "Nếu Người dùng tiếp tục sử dụng Nền tảng sau khi Điều khoản mới có hiệu lực, việc tiếp tục sử dụng đó được hiểu là Người dùng chấp thuận nội dung đã được cập nhật, trong phạm vi pháp luật cho phép."
  },
  {
    "type": "heading",
    "text": "4. Đăng ký và quản lý tài khoản"
  },
  {
    "type": "paragraph",
    "text": "Một số chức năng của Vay3Phút có thể yêu cầu Người dùng đăng ký tài khoản. Trong quá trình đăng ký hoặc sử dụng Dịch vụ, Người dùng có thể được yêu cầu cung cấp họ tên, số điện thoại, địa chỉ email và những thông tin cần thiết khác."
  },
  {
    "type": "paragraph",
    "text": "Người dùng có trách nhiệm bảo đảm thông tin cung cấp là chính xác, trung thực, đầy đủ và được cập nhật khi có thay đổi."
  },
  {
    "type": "paragraph",
    "text": "Thông tin đăng nhập và phương thức xác thực tài khoản phải được Người dùng tự bảo quản. Mọi hoạt động được thực hiện thông qua tài khoản của Người dùng có thể được xem là hoạt động do chính Người dùng thực hiện, trừ trường hợp có căn cứ chứng minh khác theo quy định pháp luật."
  },
  {
    "type": "paragraph",
    "text": "Nếu phát hiện tài khoản bị truy cập trái phép, bị mất quyền kiểm soát hoặc có dấu hiệu bị sử dụng không đúng mục đích, Người dùng cần thông báo cho Vay3Phút trong thời gian sớm nhất để được hỗ trợ."
  },
  {
    "type": "paragraph",
    "text": "Tài khoản được tạo cho một Người dùng cụ thể không được tự ý bán, chuyển nhượng, cho thuê, cho mượn hoặc chia sẻ cho người khác sử dụng nếu chưa được Vay3Phút chấp thuận hoặc pháp luật không cho phép."
  },
  {
    "type": "paragraph",
    "text": "Vay3Phút có thể yêu cầu Người dùng xác minh hoặc cập nhật thông tin nếu phát hiện dữ liệu không đầy đủ, không nhất quán hoặc có dấu hiệu bất thường."
  },
  {
    "type": "heading",
    "text": "5. Bảo vệ dữ liệu cá nhân"
  },
  {
    "type": "paragraph",
    "text": "Trong quá trình cung cấp Dịch vụ, Vay3Phút có thể cần thu thập và xử lý một số dữ liệu cá nhân của Người dùng trong phạm vi phù hợp với mục đích đã được thông báo."
  },
  {
    "type": "paragraph",
    "text": "Việc thu thập, ghi nhận, lưu trữ, sử dụng, phân tích, chia sẻ, truyền hoặc thực hiện các hoạt động xử lý dữ liệu khác sẽ được thực hiện theo Chính sách Bảo mật của Vay3Phút và các quy định pháp luật Việt Nam về bảo vệ dữ liệu cá nhân."
  },
  {
    "type": "paragraph",
    "text": "Vay3Phút áp dụng các biện pháp hợp lý nhằm bảo vệ dữ liệu cá nhân khỏi nguy cơ truy cập, sử dụng, tiết lộ, thay đổi hoặc mất mát trái phép."
  },
  {
    "type": "paragraph",
    "text": "Người dùng nên đọc Chính sách Bảo mật trước khi cung cấp dữ liệu cá nhân hoặc sử dụng các chức năng có liên quan đến việc xử lý dữ liệu."
  },
  {
    "type": "heading",
    "text": "6. Quyền sử dụng và quyền sở hữu trí tuệ"
  },
  {
    "type": "paragraph",
    "text": "Trong thời gian Người dùng tuân thủ Điều khoản này, Vay3Phút cho phép Người dùng truy cập và sử dụng Nền tảng trong phạm vi cá nhân, hợp pháp và phù hợp với mục đích của Dịch vụ."
  },
  {
    "type": "paragraph",
    "text": "Quyền sử dụng này có giới hạn, không độc quyền, không được tự ý chuyển nhượng và có thể bị chấm dứt khi Người dùng vi phạm Điều khoản hoặc trong các trường hợp khác được pháp luật cho phép."
  },
  {
    "type": "paragraph",
    "text": "Nếu chưa được Vay3Phút chấp thuận bằng văn bản, Người dùng không được:"
  },
  {
    "type": "list",
    "items": [
      "Sao chép, sửa đổi hoặc khai thác trái phép phần mềm hay nội dung của Nền tảng;",
      "Dịch ngược, giải mã, phân tích ngược hoặc tìm cách truy xuất mã nguồn;",
      "Truy cập trái phép vào máy chủ, cơ sở dữ liệu hoặc hệ thống liên quan;",
      "Sử dụng robot, chương trình tự động, công cụ thu thập hoặc khai thác dữ liệu trái phép;",
      "Can thiệp hoặc gây gián đoạn hoạt động bình thường của Nền tảng;",
      "Khai thác Nền tảng hoặc nội dung của Nền tảng cho mục đích thương mại trái phép."
    ]
  },
  {
    "type": "paragraph",
    "text": "Các quyền đối với phần mềm, thiết kế, giao diện, cơ sở dữ liệu, nội dung, hình ảnh, logo, nhãn hiệu, tên thương mại và các tài sản trí tuệ khác trên Nền tảng thuộc Vay3Phút hoặc chủ thể đã cấp quyền hợp pháp cho Vay3Phút."
  },
  {
    "type": "paragraph",
    "text": "Việc Người dùng được phép truy cập Nền tảng không đồng nghĩa với việc bất kỳ quyền sở hữu trí tuệ nào được chuyển giao cho Người dùng."
  },
  {
    "type": "heading",
    "text": "7. Giám sát và bảo đảm an toàn Nền tảng"
  },
  {
    "type": "paragraph",
    "text": "Để duy trì hoạt động an toàn và ổn định của Nền tảng, Vay3Phút có thể thực hiện các biện pháp kiểm tra và giám sát hợp lý nhằm:"
  },
  {
    "type": "list",
    "items": [
      "Bảo vệ hệ thống và dữ liệu;",
      "Xác minh thông tin do Người dùng cung cấp;",
      "Phát hiện dấu hiệu gian lận hoặc hành vi bất thường;",
      "Ngăn chặn hành vi vi phạm Điều khoản hoặc pháp luật;",
      "Bảo vệ quyền và lợi ích hợp pháp của Người dùng, Vay3Phút và đối tác."
    ]
  },
  {
    "type": "paragraph",
    "text": "Trong phạm vi được pháp luật cho phép, nội dung có dấu hiệu vi phạm có thể bị hạn chế truy cập, tạm ẩn hoặc xóa bỏ."
  },
  {
    "type": "paragraph",
    "text": "Vay3Phút có thể cung cấp thông tin cần thiết cho cơ quan nhà nước có thẩm quyền khi nhận được yêu cầu hợp pháp hoặc khi pháp luật quy định phải thực hiện."
  },
  {
    "type": "paragraph",
    "text": "Đối với giao dịch được xử lý bởi ngân hàng, cổng thanh toán hoặc đơn vị trung gian thanh toán độc lập, các sự cố phát sinh từ hệ thống, hạn mức hoặc quy trình của đơn vị đó sẽ được xử lý theo quy định của nhà cung cấp dịch vụ tương ứng."
  },
  {
    "type": "heading",
    "text": "8. Tạm ngừng và chấm dứt Dịch vụ"
  },
  {
    "type": "paragraph",
    "text": "Vay3Phút có thể tạm thời hạn chế hoặc gián đoạn một phần hay toàn bộ Dịch vụ khi cần bảo trì, nâng cấp hệ thống, xử lý sự cố kỹ thuật, bảo đảm an toàn thông tin, thực hiện yêu cầu của cơ quan có thẩm quyền hoặc vì lý do vận hành hợp lý khác."
  },
  {
    "type": "paragraph",
    "text": "Trong điều kiện cho phép, Vay3Phút sẽ cố gắng thông báo trước về những gián đoạn có thể ảnh hưởng đáng kể đến Người dùng. Tuy nhiên, việc thông báo trước có thể không thực hiện được đối với sự cố khẩn cấp hoặc tình huống nằm ngoài khả năng kiểm soát hợp lý."
  },
  {
    "type": "paragraph",
    "text": "Quyền sử dụng của Người dùng cũng có thể bị hạn chế hoặc chấm dứt khi:"
  },
  {
    "type": "list",
    "items": [
      "Người dùng vi phạm Điều khoản;",
      "Có dấu hiệu gian lận hoặc giả mạo;",
      "Nền tảng được sử dụng cho mục đích trái pháp luật;",
      "Có yêu cầu hợp pháp của cơ quan có thẩm quyền;",
      "Việc tiếp tục cung cấp Dịch vụ có thể tạo ra rủi ro đáng kể đối với Nền tảng, Người dùng khác hoặc bên thứ ba."
    ]
  },
  {
    "type": "paragraph",
    "text": "Việc chấm dứt tài khoản không làm mất hiệu lực của các quyền và nghĩa vụ đã phát sinh trước thời điểm chấm dứt."
  },
  {
    "type": "heading",
    "text": "9. Các hành vi không được phép"
  },
  {
    "type": "paragraph",
    "text": "Người dùng không được sử dụng Vay3Phút để trực tiếp hoặc gián tiếp thực hiện các hành vi sau:"
  },
  {
    "type": "list",
    "items": [
      "Vi phạm pháp luật hoặc hỗ trợ người khác thực hiện hành vi trái pháp luật;",
      "Cung cấp thông tin giả mạo, sai lệch hoặc cố ý gây hiểu nhầm;",
      "Xâm phạm quyền sở hữu trí tuệ, quyền riêng tư hoặc quyền hợp pháp của người khác;",
      "Quấy rối, đe dọa, xúc phạm, vu khống hoặc gây tổn hại cho cá nhân, tổ chức khác;",
      "Phát tán virus, mã độc hoặc chương trình gây hại;",
      "Thu thập hoặc sử dụng trái phép dữ liệu cá nhân của người khác;",
      "Thực hiện spam, lừa đảo, giả mạo hoặc tấn công mạng;",
      "Tự động thu thập hoặc khai thác dữ liệu khi chưa được phép;",
      "Vượt qua, phá hoại hoặc vô hiệu hóa các biện pháp bảo mật;",
      "Thực hiện hoạt động trái pháp luật, trái đạo đức xã hội hoặc ảnh hưởng nghiêm trọng đến hoạt động bình thường của Nền tảng."
    ]
  },
  {
    "type": "paragraph",
    "text": "Tùy theo tính chất và mức độ vi phạm, Vay3Phút có thể cảnh báo, hạn chế chức năng, tạm khóa hoặc chấm dứt tài khoản và, khi cần thiết, phối hợp với cơ quan có thẩm quyền theo quy định pháp luật."
  },
  {
    "type": "heading",
    "text": "10. Tuyên bố miễn trừ và giới hạn trách nhiệm"
  },
  {
    "type": "paragraph",
    "text": "Người dùng hiểu rằng Vay3Phút chủ yếu cung cấp giải pháp công nghệ và dịch vụ kết nối thông tin. Các sản phẩm tài chính được giới thiệu trên Nền tảng do đối tác độc lập cung cấp."
  },
  {
    "type": "paragraph",
    "text": "Vay3Phút không cam kết hoặc bảo đảm rằng hồ sơ của Người dùng chắc chắn được phê duyệt, được cấp một hạn mức cụ thể hoặc được giải ngân."
  },
  {
    "type": "paragraph",
    "text": "Người dùng có trách nhiệm tự xem xét điều kiện sản phẩm, lãi suất, phí, nghĩa vụ thanh toán, thời hạn và các nội dung của hợp đồng với đơn vị cung cấp sản phẩm trước khi đưa ra quyết định."
  },
  {
    "type": "paragraph",
    "text": "Trong phạm vi pháp luật cho phép, Vay3Phút không chịu trách nhiệm thay cho đối tác đối với:"
  },
  {
    "type": "list",
    "items": [
      "Quyết định phê duyệt hoặc từ chối hồ sơ;",
      "Việc từ chối hoặc thời gian thực hiện giải ngân;",
      "Việc thực hiện nghĩa vụ của tổ chức tài chính hoặc bên thứ ba;",
      "Tranh chấp phát sinh trực tiếp từ hợp đồng giữa Người dùng và đối tác;",
      "Thiệt hại phát sinh do Người dùng cung cấp thông tin sai hoặc thiếu."
    ]
  },
  {
    "type": "paragraph",
    "text": "Vay3Phút cũng không bảo đảm rằng Nền tảng sẽ luôn hoạt động liên tục hoặc hoàn toàn không có lỗi. Hoạt động của Dịch vụ có thể bị ảnh hưởng bởi mạng viễn thông, hệ thống của bên thứ ba, bảo trì, sự cố kỹ thuật hoặc các yếu tố nằm ngoài khả năng kiểm soát hợp lý."
  },
  {
    "type": "paragraph",
    "text": "Trong phạm vi pháp luật cho phép, Vay3Phút không chịu trách nhiệm đối với các thiệt hại gián tiếp hoặc hậu quả phát sinh từ việc không thể sử dụng Nền tảng, sự cố kỹ thuật, truy cập trái phép hoặc dịch vụ do bên thứ ba cung cấp."
  },
  {
    "type": "paragraph",
    "text": "Nếu Vay3Phút phải chịu trách nhiệm bồi thường theo quy định bắt buộc của pháp luật hoặc quyết định có hiệu lực của cơ quan có thẩm quyền, giới hạn trách nhiệm sẽ được xác định theo pháp luật áp dụng. Trong trường hợp pháp luật cho phép áp dụng giới hạn theo thỏa thuận, tổng trách nhiệm của Vay3Phút không vượt quá tổng phí Dịch vụ mà Người dùng thực tế đã thanh toán trực tiếp cho Vay3Phút trong 12 tháng trước sự kiện làm phát sinh trách nhiệm."
  },
  {
    "type": "heading",
    "text": "11. Nghĩa vụ bồi thường"
  },
  {
    "type": "paragraph",
    "text": "Trong phạm vi pháp luật cho phép, nếu hành vi của Người dùng gây ra khiếu nại, thiệt hại hoặc chi phí cho Vay3Phút hoặc các bên liên quan, Người dùng có trách nhiệm bồi thường hợp lý đối với phần thiệt hại phát sinh từ:"
  },
  {
    "type": "list",
    "items": [
      "Việc sử dụng Nền tảng trái với Điều khoản;",
      "Hành vi sử dụng Dịch vụ cho mục đích trái pháp luật;",
      "Vi phạm cam kết do Người dùng đưa ra;",
      "Xâm phạm quyền sở hữu trí tuệ, quyền riêng tư hoặc quyền hợp pháp của bên thứ ba;",
      "Nội dung trái pháp luật do Người dùng cung cấp hoặc truyền tải."
    ]
  },
  {
    "type": "paragraph",
    "text": "Khi phát sinh khiếu nại có liên quan, Người dùng đồng ý hợp tác hợp lý với Vay3Phút trong quá trình xác minh và giải quyết."
  },
  {
    "type": "paragraph",
    "text": "Các nghĩa vụ đã phát sinh theo Điều này có thể tiếp tục có hiệu lực sau khi tài khoản hoặc quyền sử dụng Dịch vụ chấm dứt, trong phạm vi pháp luật cho phép."
  },
  {
    "type": "heading",
    "text": "12. Dịch vụ và nội dung của bên thứ ba"
  },
  {
    "type": "subheading",
    "text": "Tiếng Việt"
  },
  {
    "type": "paragraph",
    "text": "Vay3Phút có thể hiển thị đường dẫn, nội dung, quảng cáo hoặc chức năng dẫn đến website, ứng dụng hoặc dịch vụ do bên thứ ba vận hành."
  },
  {
    "type": "paragraph",
    "text": "Các nền tảng của bên thứ ba được vận hành độc lập và có thể áp dụng điều khoản sử dụng, chính sách bảo mật và quy trình riêng."
  },
  {
    "type": "paragraph",
    "text": "Trừ trường hợp pháp luật có quy định khác, việc Vay3Phút hiển thị liên kết hoặc thông tin của bên thứ ba không có nghĩa Vay3Phút bảo lãnh hoặc chịu trách nhiệm thay cho bên thứ ba đó."
  },
  {
    "type": "paragraph",
    "text": "Người dùng nên tự đọc và đánh giá các điều khoản áp dụng trước khi sử dụng dịch vụ của bên thứ ba."
  },
  {
    "type": "heading",
    "text": "13. Phản hồi của Người dùng"
  },
  {
    "type": "paragraph",
    "text": "Người dùng có thể gửi ý kiến, đề xuất hoặc phản hồi liên quan đến Vay3Phút. Trừ trường hợp các bên có thỏa thuận khác, Vay3Phút có thể sử dụng những phản hồi này cho mục đích cải thiện chất lượng Dịch vụ, tối ưu tính năng hoặc phát triển sản phẩm mà không phát sinh nghĩa vụ thanh toán."
  },
  {
    "type": "paragraph",
    "text": "Người dùng phải bảo đảm rằng nội dung mình gửi không xâm phạm quyền của bên thứ ba, không chứa thông tin trái pháp luật và không chứa virus, mã độc hoặc thành phần gây nguy hiểm cho hệ thống."
  },
  {
    "type": "paragraph",
    "text": "Quy định này không có nghĩa Vay3Phút được tự do sử dụng dữ liệu cá nhân của Người dùng. Dữ liệu cá nhân vẫn được xử lý theo Chính sách Bảo mật và pháp luật Việt Nam."
  },
  {
    "type": "paragraph",
    "text": "Vay3Phút có thể sử dụng dữ liệu đã được tổng hợp hoặc ẩn danh, không còn khả năng nhận diện trực tiếp một cá nhân, cho hoạt động phân tích, nghiên cứu và cải thiện Dịch vụ trong phạm vi pháp luật cho phép."
  },
  {
    "type": "heading",
    "text": "14. Xác nhận về vai trò của Vay3Phút"
  },
  {
    "type": "paragraph",
    "text": "Người dùng một lần nữa xác nhận rằng Vay3Phút là nền tảng công nghệ hỗ trợ kết nối thông tin giữa Người dùng và các tổ chức tài chính hoặc nhà cung cấp dịch vụ liên quan."
  },
  {
    "type": "paragraph",
    "text": "Vay3Phút không trực tiếp cho vay hoặc cấp tín dụng dưới danh nghĩa của mình."
  },
  {
    "type": "paragraph",
    "text": "Nếu Người dùng lựa chọn một sản phẩm được giới thiệu trên Nền tảng, hợp đồng và giao dịch tài chính tương ứng sẽ được xác lập giữa Người dùng và đơn vị thực tế cung cấp sản phẩm, trừ trường hợp có thông báo rõ ràng khác."
  },
  {
    "type": "paragraph",
    "text": "Vay3Phút không mặc nhiên trở thành bên của hợp đồng, bên bảo lãnh hoặc bên chịu nghĩa vụ thanh toán thay cho bất kỳ bên nào trong giao dịch đó."
  },
  {
    "type": "paragraph",
    "text": "Người dùng cần chủ động kiểm tra thông tin về sản phẩm, nhà cung cấp, lãi suất, phí, thời hạn, nghĩa vụ thanh toán và các điều kiện liên quan trước khi ký kết hoặc xác nhận giao dịch."
  },
  {
    "type": "heading",
    "text": "15. Luật áp dụng và giải quyết tranh chấp"
  },
  {
    "type": "paragraph",
    "text": "Điều khoản này được điều chỉnh và giải thích theo pháp luật của Nước Cộng hòa Xã hội Chủ nghĩa Việt Nam."
  },
  {
    "type": "paragraph",
    "text": "Nếu phát sinh tranh chấp liên quan đến việc sử dụng Nền tảng hoặc Dịch vụ, các bên sẽ ưu tiên trao đổi và thương lượng trên tinh thần thiện chí để tìm phương án giải quyết phù hợp."
  },
  {
    "type": "paragraph",
    "text": "Nếu sau 30 ngày kể từ ngày một bên gửi thông báo bằng văn bản về tranh chấp mà các bên vẫn không thể giải quyết thông qua thương lượng, tranh chấp có thể được đưa ra Tòa án có thẩm quyền tại Thành phố Hồ Chí Minh, trừ trường hợp pháp luật bắt buộc quy định thẩm quyền giải quyết khác."
  },
  {
    "type": "heading",
    "text": "16. Hủy Dịch vụ và hoàn tiền"
  },
  {
    "type": "paragraph",
    "text": "Người dùng có thể gửi yêu cầu hủy Dịch vụ thông qua các kênh hỗ trợ chính thức do Vay3Phút công bố."
  },
  {
    "type": "paragraph",
    "text": "Sau khi nhận được đầy đủ thông tin cần thiết, Vay3Phút sẽ xem xét và xử lý yêu cầu trong thời gian hợp lý."
  },
  {
    "type": "paragraph",
    "text": "Việc Người dùng có được hoàn tiền hay không phụ thuộc vào loại Dịch vụ, tình trạng thực hiện giao dịch, phương thức thanh toán và quy định pháp luật áp dụng."
  },
  {
    "type": "paragraph",
    "text": "Nếu yêu cầu hoàn tiền được chấp thuận, khoản tiền thông thường sẽ được hoàn về phương thức thanh toán ban đầu, tùy theo quy trình xử lý của ngân hàng, cổng thanh toán hoặc đơn vị trung gian thanh toán tương ứng."
  },
  {
    "type": "paragraph",
    "text": "Để xác minh tính hợp lệ của yêu cầu, Vay3Phút có thể đề nghị Người dùng cung cấp thông tin hoặc chứng từ cần thiết."
  },
  {
    "type": "paragraph",
    "text": "Thời gian tiền thực tế được ghi có vào tài khoản của Người dùng có thể phụ thuộc vào quy trình xử lý của ngân hàng hoặc nhà cung cấp dịch vụ thanh toán."
  },
  {
    "type": "heading",
    "text": "17. Khiếu nại, hỗ trợ và thông tin liên hệ"
  },
  {
    "type": "paragraph",
    "text": "Nếu có câu hỏi, khiếu nại, yêu cầu hỗ trợ hoặc phản hồi liên quan đến Nền tảng, Điều khoản này hoặc Dịch vụ, Người dùng có thể liên hệ với Vay3Phút thông qua kênh chính thức dưới đây:"
  },
  {
    "type": "paragraph",
    "text": "Tên doanh nghiệp: Công ty TNHH Công nghệ VayNext\nEmail hỗ trợ: service@vay3phut.com"
  },
  {
    "type": "paragraph",
    "text": "Khi gửi yêu cầu, Người dùng nên cung cấp đầy đủ thông tin cần thiết để Vay3Phút có thể xác minh và xử lý vấn đề một cách phù hợp."
  },
  {
    "type": "paragraph",
    "text": "Vay3Phút sẽ tiếp nhận và phản hồi các yêu cầu hợp lệ trong thời gian hợp lý, tùy theo tính chất và mức độ phức tạp của từng trường hợp."
  },
  {
    "type": "paragraph",
    "text": "Điều khoản này có hiệu lực đối với Người dùng kể từ thời điểm Người dùng chấp thuận hoặc bắt đầu sử dụng Nền tảng, tùy thời điểm nào đến trước theo quy định pháp luật áp dụng."
  }
];

export default content;
